import { createAction, props } from "@ngrx/store";
import ISkillNodeWithRating from "@skills-app/models/skillNodeWithRating";

const prefix = "[Consultant Profile Page]";

export const loadPage = createAction(
  `${prefix} Load Page`,
  props<{ azureId: string }>(),
);
export const populateUserSkills = createAction(
  `${prefix} Populate User Skills`,
  props<{ skills: ISkillNodeWithRating[] }>(),
);
export const updateUserSkills = createAction(
  `${prefix} Update User Skills`,
  props<{ skills: ISkillNodeWithRating[] }>(),
);
